<template lang="pug">
  .mb-4.icon-container
    v-icon(size="45" color="neutral700") $yzi-phone-02-new
    v-icon.text-icon(size="28" color="#8A31FF") $yzi-message-dots-square
</template>

<script>
export default {
}
</script>

<style scoped>
.icon-container {
  position: relative;
}
.text-icon {
  position: absolute;
  top: -10px;
  right: 209px;
}
</style>